export const combineDateAndTimeInReadableFormat = (date, time) =>
  `${new Date(date).toLocaleDateString()} ${new Date(time).toLocaleTimeString()}`;

export const combineDateAndTime = (
  // returned min values is Minute
  date,
  time
) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes());
